import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VAutocomplete, _vm._b({
    class: {
      required: _vm.isRequired
    },
    attrs: {
      "value": _vm.value,
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "loading": _vm.isLoading,
      "disabled": _vm.isDisabled,
      "data-cy": "account_selector"
    },
    on: {
      "change": e => _vm.$emit('input', e)
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")])], 1)];
      }
    }])
  }, 'v-autocomplete', {
    ..._vm.$attrs,
    ..._vm.commonAttrs
  }, false));
};
var staticRenderFns = [];
export { render, staticRenderFns };